import { Button, Checkbox, FormControl, FormControlLabel, MenuItem, Select, TextField, Tooltip } from '@mui/material';
import { action, computed, observable, makeObservable } from 'mobx';
import {  observer } from 'mobx-react';
import React from 'react';
import { HotKeys } from 'react-hotkeys';
import ControleGabineteService from '../services/ControleGabineteService';
import UsuarioStore from '../store/UsuarioStore';
import GabineteStore from '../store/GabineteStore';
import LayoutStore from '../store/LayoutStore';
import ProcessoService from '../services/ProcessoService';
import EscaninhoService from '../services/EscaninhoService';
import InformacoesProcessoService from '../services/InformacoesProcessoService';
import TopBarStore from '../store/TopBarStore';
import Modal from '@/misc/Modal';

interface IPropsJustDev {
    children: any;
}


class JustDev extends React.Component<React.PropsWithChildren<IPropsJustDev>> {
    display = false;
    siglaGabinete = '';
    perfil = 'assessor';
    numeroProcesso = '';
    abertoModalCorrecaoNumeros = false;
    classe = false;
    sqlNumProcesso = true;

    regexClasse = /([aA-zZ]+-*\s*)*/;

    constructor(props: IPropsJustDev) {
        super(props);

        makeObservable(this, {
            display: observable,
            siglaGabinete: observable,
            perfil: observable,
            numeroProcesso: observable,
            abertoModalCorrecaoNumeros: observable,
            classe: observable,
            sqlNumProcesso: observable,
            numeroProcessoCorrigido: computed,
            toggleClasse: action,
            toggleSQL: action,
            trocaPerfil: action,
            ocGabinete: action,
            ajustaNumeroProcesso: action,
            ocPerfil: action,
            toggleDisplay: action,
            fecharModaCorrecaoNumeros: action,
            abrirModaCorrecaoNumeros: action
        });
    }

    get numeroProcessoCorrigido() {
        const numeros = [];
        const numerosSeparados = this.numeroProcesso.replace(/-|\./g, '').split('\n');
        numerosSeparados.forEach((num) => {
            num = num.replace(/\s/g,'');
            if (num.trim().length == 0) {
                return;
            }

            let classes = '';
            const regExec = this.regexClasse.exec(num);
            classes = regExec?.length > 1 ? regExec[0].trim() : '';
            num = num.substring(classes.length).trim();

            const vara = num.substring(num.length - 4);
            const tribunal = num.substring(num.length - 6, num.length - 4);
            const justica = num.substring(num.length - 7, num.length - 6);
            const ano = num.substring(num.length - 11, num.length - 7);
            const digito = num.substring(num.length - 13, num.length - 11);
            const numero = num.substring(0, num.length - 13);
            numeros.push((this.classe ? (classes + ' - ') : '') + numero + '-' + digito + '.' + ano + '.' + justica + '.' + tribunal + '.' + vara);
        });
        if (this.sqlNumProcesso) {
            const sql = numeros.map((num, index) => {
                return 'TXT_PROCESSO_COMPLETO LIKE \'%' + num + '%\'' + (index != numeros.length - 1 ? ' OR ' : '')
            });
            return [].concat(sql);
        }
        return numeros;
    }


    toggleClasse = () => {
        this.classe = !this.classe;
    };
    toggleSQL = () => {
        this.sqlNumProcesso = !this.sqlNumProcesso;
    };

    trocaPerfil = async () => {
        const novaUsuarioLocalizacaoList = {
            usuarioLocalizacaoMagistradoServidor: {
                orgaoJulgador: {
                    sigla: this.siglaGabinete,
                }
            },
            siglaOrgaoJulgador: this.siglaGabinete,
            papel: [{
                identificador: this.perfil,
                nome: this.perfil,
                perfil: this.perfil
            }]
        }

        const novaLocalizacao = {
            papel: [{ perfil: this.perfil }],
            siglaOrgaoJulgador: this.siglaGabinete,
            usuarioLocalizacaoMagistradoServidor: {
                orgaoJulgador: {
                    sigla: this.siglaGabinete,
                }
            },

        }

        UsuarioStore.usuario.usuarioLocalizacaoList.push(novaUsuarioLocalizacaoList);
        UsuarioStore.usuario.localizacao = novaLocalizacao;
        UsuarioStore.localizacao = UsuarioStore.usuario.usuarioLocalizacaoList[UsuarioStore.usuario.usuarioLocalizacaoList.length - 1];

        Promise.resolve([
            await GabineteStore.inicializar(),
            await ControleGabineteService.atualizarControlesGabinete(),
            await EscaninhoService.carregarProcessosDoGabinete(),
            // BTV desativado: os dados retornados não têm consumidores no frontend.
            // await InformacoesProcessoService.buscarDadosProcessoBTV(UsuarioStore.gabinete)
        ]);

    };

    ocGabinete = (event) => {
        this.siglaGabinete = event.target.value.toUpperCase();
    };

    ajustaNumeroProcesso = (event) => {
        this.numeroProcesso = event.target.value;
    };

    ocPerfil = (event) => {
        this.perfil = event.target.value;
    };

    toggleDisplay = () => {
        this.display = !this.display;
        // Espelha o estado para o TopBarStore para que o MenuPrincipal
        // possa alargar a barra lateral enquanto o painel dev estiver aberto.
        TopBarStore.setJustDevAberto(this.display);
    };

    handlers = {
        tooggleDisplay: this.toggleDisplay,
        toggleDisplayUnix: this.toggleDisplay
    }

    keyMap = {
        tooggleDisplay: 'alt+shift+c+d+s',
        toggleDisplayUnix: 'c+d+s'
    }


    fecharModaCorrecaoNumeros = () => {
        this.abertoModalCorrecaoNumeros = false;
    };

    abrirModaCorrecaoNumeros = () => {
        this.abertoModalCorrecaoNumeros = true;
    };

    render() {
        return (
            <HotKeys handlers={this.handlers} keyMap={this.keyMap}>
                {this.props.children}
                <div id='justdevcds' style={{ margin: '10px', display: this.display ? 'flex' : 'none', flexDirection: 'column', gap: '12px' }}>
                    <FormControlLabel
                        control={
                            <Checkbox
                                onClick={LayoutStore.toggleTema}
                                checked={!!LayoutStore.isTemaDark}
                                id='temaLigthDark'
                                color="primary" />
                        }
                        label={'Usar tema escuro'}
                    />
                    <div style={{ display: 'flex', flexDirection: 'column', gap: '8px' }}>
                        <TextField value={this.siglaGabinete ?? ''} onChange={this.ocGabinete} label='Sigla' id='justDevSigla' />
                        <Select value={this.perfil ?? ''} style={{ width: '100%' }} onChange={this.ocPerfil} id='selectPapel'>
                            <MenuItem value={"assessor"}>Assessor</MenuItem>
                            <MenuItem value={"secretario"}>Secretário</MenuItem>
                            <MenuItem value={"magistrado"}>Magistrado</MenuItem>
                            <MenuItem value={"administrador"}>Administrador</MenuItem>
                        </Select>
                        <Button variant='contained' color='primary' onClick={this.trocaPerfil} sx={{ alignSelf: 'flex-start', maxWidth: 240 }}>
                            trocar perfil
                        </Button>
                    </div>
                    <div>
                        <Tooltip title='correção de numeros'>
                            <div>
                                <Button onClick={this.abrirModaCorrecaoNumeros} variant='contained' sx={{ alignSelf: 'flex-start', maxWidth: 240 }}>
                                    correção de numeros
                                </Button>
                            </div>
                        </Tooltip>
                    </div>
                    <Modal
                        aberto={this.abertoModalCorrecaoNumeros}
                        funcaoAcaoSecundaria={this.fecharModaCorrecaoNumeros}
                        labelAcaoSecundaria='Cancelar'
                        titulo='Corrigir numeros de processo'
                        fecharModal={this.fecharModaCorrecaoNumeros}
                        maxWidth='lg'
                    >
                        <div>
                            com classe: <Checkbox color='primary' checked={this.classe} onClick={this.toggleClasse} />
                        </div>
                        <div>
                            sql para achar id no tg: <Checkbox color='primary' checked={this.sqlNumProcesso} onClick={this.toggleSQL} />
                        </div>

                        <FormControl fullWidth style={{ width: '600px' }}>
                            <TextField multiline
                                minRows={1}
                                maxRows={10}
                                variant='outlined'
                                value={this.numeroProcesso}
                                onChange={this.ajustaNumeroProcesso}
                                label='numeros'
                                id='numeroProcesso' />
                        </FormControl>
                        {this.numeroProcessoCorrigido.map((num, index) => {
                            return (<div key={index}>{num}</div>);
                        })}
                    </Modal>
                </div>
            </HotKeys>
        );
    }
}

export default observer(JustDev);
